import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'replaceLineBreaks'
})
export class ReplaceLineBreaksPipe implements PipeTransform
{
  public transform(value: string): string
  {
    if (!value)
    {
      return value;
    }

    const normalized = String(value)
      .replace(/\\r\\n/g, '\n')
      .replace(/\\n/g, '\n')
      .replace(/\\r/g, '\n')
      .replace(/\r\n/g, '\n')
      .replace(/\r/g, '\n');
    return normalized.replace(/\n/g, '<br/>');
  }
}
